import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { OutboxService } from 'src/app/shared/services/outbox/outbox.service';
import { NgIf, NgStyle } from '@angular/common';
import { LtmsLoaderComponent } from '../../../../../../shared/components/ltms-loader/ltms-loader.component';
import { LtmsDataTableV2Component } from '../../../../../../shared/components/ltms-data-table-v2/ltms-data-table-v2.component';

@Component({
    selector: 'app-outbox-multi-request-upload-history',
    templateUrl: './outbox-multi-request-upload-history.component.html',
    styleUrl: './outbox-multi-request-upload-history.component.scss',
    imports: [NgIf, LtmsLoaderComponent, LtmsDataTableV2Component, NgStyle]
})
export class OutboxMultiRequestUploadHistoryComponent implements OnInit, OnChanges {
  // @Input() tableData: any[] = [];
  uploadHistory: any[] = [];
  errorCode;
  isDataLoaded: boolean = false;
  brandDetail: any = {}
  brandOffsetName: any = {}
  pagingDetails: any = {
    start: 0,
    end: 0,
    pageSize: 10,
    pageNumber: 1,
    total: 0,
    totalpages: 1
  }
  pagingButtons: any = {
    isNext: false,
    isPrevious: false,
  }
  headers: any[] = [
    {
      "header": "File Name",
      "dataKey": "original_file_name",
      "dataType": 'string',
      "order": 1,
      "width": "20%",
      "sortingEnabled": false,
      "enabled": true,
      "style": {
        "headerTextAlign": 'left',
        "cellTextAlign": 'left',
        "width": "18%",
        "class": "ltms-ellipsis-cell"
      },
      isInfoIconVisible: true
    },
    {
      "header": "Uploaded On",
      "dataKey": "created_date",
      "dataType": 'string',
      "order": 2,
      "width": "20%",
      "sortingEnabled": false,
      "enabled": true,
      "style": {
        "headerTextAlign": 'left',
        "cellTextAlign": 'left',
        "width": "15%",
      }
    }, {
      "header": "Status",
      "dataKey": "status",
      "dataType": 'string',
      "order": 3,
      "width": "20%",
      "sortingEnabled": false,
      "enabled": true,
      "style": {
        "headerTextAlign": 'left',
        "cellTextAlign": 'center',
        "width": "10%",
      }
    }, {
      "header": "Processed On",
      "dataKey": "processed_date",
      "dataType": 'date',
      "order": 4,
      "width": "20%",
      "sortingEnabled": false,
      "enabled": true,
      "style": {
        "headerTextAlign": 'left',
        "cellTextAlign": 'left',
        "width": "15%",
      },
    },
    {
      "header": "Uploaded by",
      "dataKey": "request_uploaded_by_name",
      "dataType": 'string',
      "order": 5,
      "width": "20%",
      "sortingEnabled": false,
      "enabled": true,
      "style": {
        "headerTextAlign": 'left',
        "cellTextAlign": 'left',
        "width": "10%",
        "class": "ltms-ellipsis-cell"
      },
      // isInfoIconVisible: true
    },{
      "header": "Total",
      "dataKey": "total_records",
      "dataType": 'number',
      "order": 6,
      "width": "20%",
      "sortingEnabled": false,
      "enabled": true,
      "style": {
        "headerTextAlign": 'left',
        "cellTextAlign": 'right',
        "width": "6%",
      }
    }, {
      "header": "Empty",
      "dataKey": "empty_rows",
      "dataType": 'number',
      "order": 7,
      "width": "20%",
      "sortingEnabled": false,
      "enabled": true,
      "style": {
        "headerTextAlign": 'left',
        "cellTextAlign": 'right',
        "width": "6%",
      }
    }, {
      "header": "Duplicate Entries",
      "dataKey": "duplicate_rows",
      "dataType": 'number',
      "order": 8,
      "width": "20%",
      "sortingEnabled": false,
      "enabled": true,
      "style": {
        "headerTextAlign": 'left',
        "cellTextAlign": 'right',
        "width": "8%",
      }
    },
    {
      "header": "Correct",
      "dataKey": "correct_records",
      "dataType": 'number',
      "order": 9,
      "width": "20%",
      "sortingEnabled": false,
      "enabled": true,
      "style": {
        "headerTextAlign": 'left',
        "cellTextAlign": 'right',
        "width": "6%",
      }
    },
    {
      "header": "Incorrect Touchpoints",
      "dataKey": "invalid_app_id_count",
      "dataType": 'number',
      "order": 10,
      "width": "20%",
      "sortingEnabled": false,
      "enabled": true,
      "style": {
        "headerTextAlign": 'left',
        "cellTextAlign": 'right',
        "width": "8%",
      }
    }, {
      "header": "Incorrect Parameters",
      "dataKey": "invalid_params",
      "dataType": 'number',
      "order": 11,
      "width": "20%",
      "sortingEnabled": false,
      "enabled": true,
      "style": {
        "headerTextAlign": 'left',
        "cellTextAlign": 'right',
        "width": "8%",
      }
    }];
  isLoading: any;
  constructor(private _outboxService: OutboxService, private _helpers: HelpersService) { }

  ngOnInit(): void {
    this.brandDetail = Helpers.brandDetails
    this.brandOffsetName = this._helpers.getBrandTimezoneDetails(this.brandDetail);
    // this.headers = this.headers.map(header => ({
    //   ...header,
    //   style: {
    //     ...header.style,
    //     whiteSpace: "normal"
    //   }
    // }));
  }
  ngOnChanges() {
    // this.updatePagingDetails(this.tableData.length, 1)  
  }

  initializeDefaults() {
    this.uploadHistory = [];
    this.pagingDetails = {
      start: 0,
      end: 0,
      pageSize: 10,
      pageNumber: 1,
      total: 0,
      totalpages: 1
    };
  }

  getUploadHistory() {
    this.isLoading = true;    
  this.isDataLoaded = false;
    this._outboxService.getMultiRequestUploadHistory(this.brandDetail?._id, this.pagingDetails.pageNumber).subscribe(res => {
      this.uploadHistory = res?.data?.litmus_jobs || [];
  
      if (this.uploadHistory.length) {
        this.uploadHistory = this.uploadHistory.map(item => {
          if (item?.created_date || item?.parameters?.processed_date) {
            item.created_date = this._helpers.getTimeByOffset(
              this.brandOffsetName["__zone_symbol__value"]['offset'],
              item['created_date'],
              "DD MMM 'YY HH:mm"
            );
  
            const status = item?.parameters?.status || "uploaded";
            let processedDate = item?.parameters?.processed_date || "NA";
  
            if (status === "uploaded" || status === "processing") {
              processedDate = "--";
            } else {
              processedDate = this._helpers.getTimeByOffset(
                this.brandOffsetName["__zone_symbol__value"]['offset'],
                item?.parameters?.processed_date,
                "DD MMM 'YY HH:mm"
              );
            }
  
            item.original_file_name = item?.parameters?.original_file_name || "NA";
            item.status = status || "Uploaded";
            item.processed_date = processedDate;
            item.total_records = item.parameters?.total_records || 0;
            item.empty_rows = item.parameters?.empty_rows || 0;
            item.duplicate_rows = item.parameters?.duplicate_rows || 0;
            item.correct_records = item.parameters?.correct_records || 0;
            item.invalid_app_id_count = item.parameters?.invalid_app_id_count || 0;
            item.invalid_params = item.parameters?.invalid_params || 0;
          }
  
          if (item?.parameters?.request_uploaded_by_name == "historical_data" || item?.request_uploaded_by_name == "historical_data") {
            item.request_uploaded_by_name = "NA";
          }
          else {
            if (item?.request_uploaded_by_name || item?.parameters?.request_uploaded_by_name || item?.request_uploaded_by_username || item?.parameters?.request_uploaded_by_username) {
              let name = item.parameters.request_uploaded_by_name || item.request_uploaded_by_name || item.request_uploaded_by_username || item.parameters.request_uploaded_by_username;
              if (typeof name === 'string') {
                item.tooltip_text = item.tooltip_text || {};
                item.tooltip_text.request_uploaded_by_name = name;
                item.request_uploaded_by_name = name.length > 8 ? name.substring(0, 10) + '...' : name;
              } else {
                item.request_uploaded_by_name = name;
              }
            }
            else {
              item.request_uploaded_by_name = "Uploaded_by_SFTP";
            }
          }

          if (item?.parameters?.is_excluded_from_analytics) {
            item.info = {
              original_file_name: "Excluded from statistics"
            };
          }
  
          return item;
        });
  
        this.updatePagingDetails(this.uploadHistory.length, this.pagingDetails.pageNumber);
      }
  
      this.isDataLoaded = true;
      this.isLoading = false;
    });
  }
  



paginateOutbox(pagingType: string) {

  if (pagingType === 'next') {
    this.pagingDetails.pageNumber++;
    this.pagingButtons.isNext = false; // disable next until data loads
  } else if (pagingType === 'previous' && this.pagingDetails.pageNumber > 1) {
    this.pagingDetails.pageNumber--;
    this.pagingButtons.isPrevious = false; // disable previous until data loads
  }

  this.getUploadHistory();
}

updatePagingDetails(numberOfRecords: number, pageNumber: number) {
  const pageSize = 10;
  const totalFetched = numberOfRecords;

  const start = totalFetched > 0 ? ((pageNumber - 1) * pageSize) + 1 : 0;
  const end = start + totalFetched - 1;

  this.pagingDetails = {
    start,
    end,
    pageSize,
    pageNumber,
    total: end,                // total = records seen so far
    totalpages: pageNumber     // we only know current page
  };

  // Disable Next if less than pageSize records came → last page
  this.pagingButtons.isNext = totalFetched === pageSize;
  this.pagingButtons.isPrevious = pageNumber > 1;

  if (totalFetched === 0) {
    this.pagingButtons.isNext = false;
    this.pagingButtons.isPrevious = false;
  }

  this.isLoading = false;
}
}
